import React, { PropsWithChildren } from 'react';
import cn from 'clsx';

import styles from './alt-button-group.scss';

function AltButtonGroup(props: PropsWithChildren<{}>) {
  const { children } = props;
  return (
    <div className={cn(styles['container'], 'alt-button-group')}>
      {children}
    </div>
  );
}

export default AltButtonGroup;
